"use client";

import Navigation from "./landing/Navigation";
import HeroSection from "./landing/HeroSection";
import HowItWorks from "./landing/HowItWorks";
import Features from "./landing/Features";
import ValueSection from "./landing/ValueSection";
import FinalCta from "./landing/FinalCta";
import Footer from "./landing/Footer";
import { usePageMeta } from "@/components/hooks/usePageMeta";

export default function LandingPage() {
  usePageMeta({
    title: "AI Job Tailored Resume Builder, ATS-Friendly",
    description:
      "Tailor your resume to any job description with AI. Get a live job match score, refine each section with AI and download ATS-friendly PDF resumes. Free to start.",
    path: "/",
  });
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
      <Navigation />
      <HeroSection />
      <HowItWorks />
      <Features />
      <ValueSection />
      <FinalCta />
      <Footer />
    </div>
  );
}
